import { ConnectionObject, ConnectionObjectForm } from '@bo-client/shared/models/connectionObject';
import { ContactDataDto, ContactDataForm } from '@bo-client/shared/models/contactDataDto';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActionDtoModel } from '@bo-client/activation-management/shared/models/actionModel';
import {
  ActionTypeEnum,
  AreaTypeEnum,
  CommissioningPowerMeterType,
  CommonStatusEnum
} from '@bo-client/activation-management/shared/models/commissioningModel';
import { MobileConnectionStrengthEnum } from '@bo-client/activation-management/shared/commissioning-constans';
import { DocumentDtoModel, UploadForm } from '@bo-client/shared/models/documentDto';
import { UserDecisionEnum } from '@bo-client/shared/constants/enums';
import { ReasonForDisconnectionEnum } from '@bo-client/activation-management/shared/models/reasonForDisconnectionEnum';

export class ExternalCommissioningRequestModel {
  /**
   * Die Sparten-IDs sind die festen IDs der Tabelle `hap_area_type` und in jeder Umgebung identisch
   * (siehe `core/seed/support/Areas.java` in netz-services): Gas 1, Strom 2, Glasfaser 3, Wasser 5,
   * Fernwärme 6 — ID 4 ist eine zurückgezogene Sparte und bewusst unbelegt.
   */
  constructor(actionType: ActionTypeEnum, meterType: CommissioningPowerMeterType, areaType: AreaTypeEnum) {
    this.actions[0].actionType = actionType;
    this.actions[0].meterType = meterType;
    switch (areaType) {
      case AreaTypeEnum.GAS:
        this.area = {
          id: 1,
          description: 'Gas',
          name: AreaTypeEnum.GAS
        };
        break;
      case AreaTypeEnum.POWER:
        this.area = {
          id: 2,
          description: 'Strom',
          name: AreaTypeEnum.POWER
        };
        break;
      case AreaTypeEnum.WATER:
        this.area = {
          id: 5,
          description: 'Wasser',
          name: AreaTypeEnum.WATER
        };
        break;
      case AreaTypeEnum.DISTRICTHEAT:
        this.area = {
          id: 6,
          description: 'Fernwärme',
          name: AreaTypeEnum.DISTRICTHEAT
        };
        break;
    }
  }
  actions: [ActionDtoModel] = [
    {
      actionType: ActionTypeEnum.change,
      meterType: CommissioningPowerMeterType.iMSys,
      devices: [],
      existingDevice: { deviceType: null },
      mobileConnectionStrength: null,
      isFeederPresent: null,
      feederType: null,
      isConsumerPresent: null,
      consumerType: null,
      isAnnualConsumptionExceeded: null,
      inspection: {}
    }
  ];
  area = {
    id: 2,
    description: 'Strom',
    name: AreaTypeEnum.POWER as AreaTypeEnum
  };
  companyLocation: {
    external_id: string;
  } = {
    external_id: null
  };
  connectionObject: ConnectionObject = {};
  customer: ContactDataDto = {};
  id: number = null;
  state = CommonStatusEnum.Requested;

  supplyAppointment: Date = null;
  supplyAppointmentWishDate: Date = null;
  supplyAppointmentWishPartday: string = null;

  uploads: DocumentDtoModel[] = [];
  comment?: string;
}

export type ImSysCommissioningRequestForm = FormGroup<{
  connectionObject: ConnectionObjectForm;
  connectionObjectValid: FormControl<boolean>;
  customer: FormArray<ContactDataForm>;
  technicalData: FormGroup<{
    meterNumber: FormControl<string>;
    deviceType: FormControl<string>;
    mobileConnectionStrength: FormControl<MobileConnectionStrengthEnum>;
    uploads: FormArray<UploadForm>;
    isFeederPresent: FormControl<UserDecisionEnum>;
    feederType: FormControl<string>;
    isConsumerPresent: FormControl<UserDecisionEnum>;
    consumerType: FormControl<string>;
    isAnnualConsumptionExceeded: FormControl<UserDecisionEnum>;
  }>;
  acceptConditions: FormControl<boolean>;
  acceptPricingTable?: FormControl<boolean>;
}>;

export type MeterInspectionForm = FormGroup<{
  area: FormControl<AreaTypeEnum>;
  customer: FormArray<ContactDataForm>;
  connectionObject: ConnectionObjectForm;
  connectionObjectValid: FormControl<boolean>;
  supplyAppointment: FormGroup<{
    date: FormControl<Date>;
    time: FormControl<string>;
    supplyAppointmentWishDate: FormControl<Date>;
    supplyAppointmentWishPartday: FormControl<string>;
  }>;
  technicalData: FormGroup<{
    meterNumber: FormControl<string>;
    exceedingExpectedConsumption: FormControl<boolean>;
    causesNoise: FormControl<boolean>;
    comment: FormControl<string>;
  }>;
  furtherInformation: FormGroup<{
    permissionToOpenDevice: FormControl<boolean | null>;
    requestsAttendance: FormControl<boolean>;
    acceptCostCondition: FormControl<boolean>;
    acceptCommissionCondition: FormControl<boolean>;
  }>;
  acceptConditions: FormControl<boolean>;
}>;

export type GridDisconnectionForm = FormGroup<{
  customer: FormArray<ContactDataForm>;
  connectionObject: ConnectionObjectForm;
  connectionObjectValid: FormControl<boolean>;
  acceptConditions: FormControl<boolean>;
  supplyAppointment: FormGroup<{
    date: FormControl<Date>;
    time: FormControl<string>;
    supplyAppointmentWishDate: FormControl<Date>;
    supplyAppointmentWishPartday: FormControl<string>;
  }>;
  technicalConnection: FormGroup<{
    meterNumber: FormControl<string>;
    isHomeOwner: FormControl<boolean | null>;
    reasonForDisconnection: FormControl<ReasonForDisconnectionEnum | null>;
    comment: FormControl<string>;
  }>;
}>;
